/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_About_P2Inputs */

const en_vc_about_p2 = /** @type {(inputs: Vc_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is one of the Crafting Apps from the ArtCraft team, alongside PhotoCraft (images), FilmCraft (video) and PdfCraft (PDF). The project started on GitHub in late September 2026 and was called DrawCraft until it was renamed in October 2026. New releases ship every few days.`)
};

const zh_vc_about_p2 = /** @type {(inputs: Vc_About_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`它是 ArtCraft 团队「Crafting Apps」系列的一员，同系列还有 PhotoCraft（图片）、FilmCraft（视频）和 PdfCraft（PDF）。项目于 2026 年 9 月底在 GitHub 上线，最初叫 DrawCraft，2026 年 10 月改名为 VectorCraft，每隔几天就会发布新版本。`)
};

/**
* | output |
* | --- |
* | "It is one of the Crafting Apps from the ArtCraft team, alongside PhotoCraft (images), FilmCraft (video) and PdfCraft (PDF). The project started on GitHub in ..." |
*
* @param {Vc_About_P2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_about_p2 = /** @type {((inputs?: Vc_About_P2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_About_P2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_about_p2(inputs)
	return zh_vc_about_p2(inputs)
});
export { vc_about_p2 as "vc.about.p2" }